export const USER_TABLE_COLUMNS = [
  { field: 'dg_ts_insert', align: 'right', width: 160, type: 'date' },
  {
    field: 'nombre',
    align: 'right',
    cellStyle: {
      textTransform: 'uppercase',
    },
  },
  {
    field: 'apellidos',
    align: 'left',
    cellStyle: {
      textTransform: 'uppercase',
    },
  },
  {
    field: 'estado',
    align: 'center',
    sorting: false,
  },
  {
    field: 'email',
    align: 'center',
  },
  {
    field: 'identificador',
    align: 'left',
    width: 120,
    cellStyle: {
      textTransform: 'uppercase',
    },
  },
]

export const USER_TABLE_ACTIONS = [
  {
    field: 'actions',
    width: 80,
    align: 'center',
    sorting: false,
  },
]

export const USER_TABLE_FILTERS = []
